//imports
import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import { useState, useEffect } from "react";
import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Menumealdata } from "../../assets/Griddata"; // Import dataset
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_16 } from "../../api/ApiModel";
import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import CircularProgress from "@mui/material/CircularProgress";
import {
  currencyFormat,
  currencyFormatLKR,
} from "../../../src/utils/common/CurrencyFormat";
import SearchAppBar from "../../components/common/search";
import { useSelector, useDispatch } from "react-redux";
function ViewMenumeal() {
  //hooks
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE } = SYS_USER.USER_PARAM || {};

  useEffect(() => {
    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      MENUNAME: item.MENUNAME,

      ITEMRATE: currencyFormatLKR(item.ITEMRATE, "LKR", false),
      MEASURINGUNIT: item.MEASURINGUNIT,
      KITCHENITEM: item.KITCHENITEM,
      MINORDERLEVEL: item.MINORDERLEVEL,
      ISTAXAPPLY: item.ISTAXAPPLY,
      IMAGEPATH: item.IMAGEPATH,
      BARCODE: item.BARCODE,
      REMARK: item.REMARK,
      MENUCODE: item.MENUCODE,
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.MENUNAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.RATE.toString().toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const fetchData = async () => {
    try {
      const result = await externalgetApi(SETTINGS_API_16, "get", {
        COMPCODE,
        LOCCODE,
        RESTCODE,
      });

      console.log("result prom", result);
      setData(result);
      setIsLoading(false);
    } catch (err) {
      setError(err);
      setIsLoading(false);
    }
  };
  //handlers
  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.MENUCODE === id);
      if (selectedItem) {
        navigate(`/setupMenumeal`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/setupMenumeal`, { state: { selectedItem: "" } });
    }
  };

  const gotToAddItems = () => {
    navigate("/setupMenumeal");
  };
  const gotoMenuPage1 = () => {
    navigate("/pathToViewItems");
  };

  const gotoMenuPage2 = () => {
    navigate("/pathToGotoPage");
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (MENUCODE) => handleItemClick(MENUCODE, "Edit"),
    },
  ];

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Promotions</Link>
                <Link underline="none">Item Details</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => gotToAddItems()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Menumealdata.columns}
          rows={rows.map((item) => ({ ...item, id: item.MENUCODE }))}
          menuItems={menuItems}
          tabletitle={Menumealdata.name}
          gridid="MENUCODE"
        />
      )}
    </div>
  );
}

export default ViewMenumeal;
